import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';
// import config from "../../config";
import { ueepci_item } from '../../json/ueepci';
import './ueepci.css';

// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const UEEPCI = () => {  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    return (
    <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <h1 className='title'>Unidad Especializada de Ética y de Prevención de Conflictos de Interés</h1>
            <hr className='hr-gob'/>
          </div>
          {
                 ueepci_item.map((item, index)=>(
                  <Link key={ index }  target="_blank" to={ item.url ? item.url : "DetalleRubros/" + item.nombre } className='col-md-4 col-sm-6 col-12 ligas_enlace'>
                    <div className='ligas_container'>
                      <div className='ligas_icono'>
                        <img src={"http://cdn.hidalgo.gob.mx/plantilla_secretarial/Rubros/PNG/" + item.icono }/>
                      </div>
                      <h3>{ item.nombre }</h3>
                    </div>
                  </Link>
                ))
            }
            {/* <Link className='rubros_historicos' to="RubrosHistoricos">Información Ejercicios Anteriores Art. 69 (48 Fracciones)</Link> */}
        </div>
    </div>
  )
}


export default UEEPCI